import { render, staticRenderFns } from "./gl-blockchain-icon.vue?vue&type=template&id=a30c04b2"
import script from "./gl-blockchain-icon.vue?vue&type=script&lang=js"
export * from "./gl-blockchain-icon.vue?vue&type=script&lang=js"
import style0 from "./gl-blockchain-icon.vue?vue&type=style&index=0&id=a30c04b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports